import React, { useState, useEffect } from 'react';
import './CustomPricingBanner.css';

/**
 * CustomPricingBanner
 * Displays a visual indicator when a customer with custom pricing is selected.
 * Allows dismissal and automatically hides when customer is cleared.
 */
const CustomPricingBanner = ({ selectedCustomer, onDismiss }) => {
  const [isDismissed, setIsDismissed] = useState(false);

  // Reset dismiss state when customer changes
  // Must be before the early return (React hooks must always be called in same order)
  useEffect(() => {
    setIsDismissed(false);
  }, [selectedCustomer?.customer_id]);

  // Don't show if:
  // - No customer selected
  // - Customer doesn't have custom pricing (_hasCustomPricing flag is false)
  // - Banner is dismissed
  if (!selectedCustomer || !selectedCustomer._hasCustomPricing || isDismissed) {
    return null;
  }

  const handleDismiss = () => {
    setIsDismissed(true);
    if (onDismiss) {
      onDismiss();
    }
  };

  return (
    <div className="custom-pricing-banner">
      <div className="banner-content">
        <div className="banner-icon">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="10" cy="10" r="9" stroke="currentColor" strokeWidth="1.5" />
            <path
              d="M10 6V10M10 14H10.01"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <div className="banner-text">
          <span className="banner-label">Custom Pricing Active</span>
          <span className="banner-customer">{selectedCustomer.customer_name}</span>
        </div>
      </div>
      <button
        type="button"
        className="banner-close"
        onClick={handleDismiss}
        aria-label="Dismiss custom pricing banner"
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 4L4 12M4 4L12 12"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </svg>
      </button>
    </div>
  );
};

export default CustomPricingBanner;
